<template>
  <div draggable="true" class="upload-files" @drop.prevent="drop" @dragover.prevent @dragstart="dragStart">
    <div class="upload-files__import text-center">
      <i class="upload-files__import-icon icon-ln-shipbob-logo" />
      <label
        for="fileUpload"
        class="upload-files__import-text font-weight-bold font-size-18"
        @click.prevent="()=>{}"
      >
        {{ $t('dragText') }} <a href="#" @click.prevent="browse">{{ $t('browse') }}</a> {{ $t('upload') }}
      </label>
      <input
        v-show="false"
        id="fileUpload"
        ref="fileUpload"
        type="file"
        name="fileUpload"
        @change="uploadFile"
      >
      <p class="upload-files__import-file-types">
        {{ $t('allowedFiles') }} {{ displayFileTypes }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UploadFile',
  props: {
    fileTypes: {
      type: Array,
      required: true,
      validator (value) {
        const acceptedFileTypes = ['excel', 'csv']
        value.forEach(v => {
          if (acceptedFileTypes.indexOf(v) === -1) {
            console.warn(`Unsupported file type. Accepted file types are ${acceptedFileTypes.join(',')}`)
            return false
          }
        })
        return true
      }
    }
  },
  data () {
    return {
      dragDropUploadSupported: false,
      fileUpload: null
    }
  },
  computed: {
    acceptedFileTypes: function () {
      return this.fileTypes.reduce((acc, ft) => {
        switch (ft) {
          case 'excel': {
            acc.concat('.xls', '.xlsx')
            break
          }
          case 'csv': {
            acc.push('.csv')
          }
        }
        return acc
      }, [])
    },
    displayFileTypes: function () {
      let fileTypesToDisplay = ''
      this.fileTypes.forEach((fileType, index) => {
        fileTypesToDisplay += `${fileType.toUpperCase()}${index === this.fileTypes.length - 1 ? '' : ', '}`
      })
      return fileTypesToDisplay
    }
  },
  created () {
    this.dragDropUploadSupported = this.isDragDropUploadSupported()
  },
  methods: {
    emitUploadedFile: function (file) {
      this.$emit('uploadedFile', file)
    },
    drop: function (ev) {
      Array(...ev.dataTransfer.files).forEach(f => {
        this.emitUploadedFile(f)
      })
    },
    dragStart: function (ev) {},
    isDragDropUploadSupported: function () {
      const div = document.createElement('div')
      return (
        ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
        'FormData' in window &&
        'FileReader' in window
      )
    },
    uploadFile: function (ev) {
      Array(...ev.target.files).forEach(f => {
        this.emitUploadedFile(f)
      })
    },
    browse: function () {
      document.getElementById('fileUpload').click()
    }
  },
  i18n: {
    messages: {
      'en-US': {
        cancel: 'Cancel',
        allowedFiles: 'Allowed Files:',
        dragText: 'Drag files here or click',
        browse: 'browse',
        upload: 'to upload'
      },
      'ja-JP': {
        cancel: 'キャンセル',
        allowedFiles: '許可されるファイル：',
        dragText: 'ここでファイルをドラッグするか、をクリックします',
        browse: 'ブラウズ ',
        upload: 'アップロードする'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.upload-files {
  &__import {
    background: #fbfbfb;
    border-radius: 9px;
    border: 3px dashed #ccd0d2;
    margin-bottom: 1.5rem;
    margin-left: -3.2rem;
    margin-top: 2rem;
    padding: 3.8rem 1rem 2.5rem;
    width: calc(100% + 6.4rem);
  }

  &__import-icon {
    color: #798fb2;
    display: block;
    font-size: 3.4rem;
    margin-bottom: 1rem;
    opacity: 0.37;
  }

  &__import-file-types {
    font-size: 0.875rem;
    margin-top: 0;
    color: #798fb2;
  }

  &__import-text {
    color: #343e4f;
  }
}
</style>
